import { useState } from "react";
import '../../styles/search.css';

export default function SearchBar() {

    const [ search, setSearch ] = useState({
        date_from: '',
        date_to: '',
        adults: "2"
    });

    const handleChange = e => {
        const { name, value } = e.target;
        setSearch((prevData) => ({
          ...prevData,
          [name]: String(value)
        }));
    };

    const handleSubmit = e => {
        e.preventDefault();
        window.open(
            `https://22222.bed-booking.com/?dateFrom=${String(search.date_from)}&dateTo=${String(search.date_to)}&source=All%20room&roomId=%22%22&people=${search.adults}`,
            '_blank'
        )
    };

    return (
        <div className="dev-searchbar">
            <form onSubmit={handleSubmit}>
                <label>
                    <p>Przyjazd:</p>
                    <input
                        type="date"
                        name="date_from"
                        value={search.from}
                        onChange={handleChange}
                    />
                </label>
                <label>
                    <p>Wyjazd:</p>
                    <input
                        type="date"
                        name="date_to"
                        value={search.to}
                        onChange={handleChange}
                    />
                </label>
                <label>
                    <p>Osoby:</p>
                    <input
                        type="number"
                        name="adults"
                        min="1"
                        defaultValue="2"
                        value={search.people}
                        onChange={handleChange}
                    />
                </label>
                <input
                    type="submit"
                    value="Szukaj"
                    
                />
            </form>
        </div>
    )
}